import { render, staticRenderFns } from "./LangItem.vue?vue&type=template&id=bfb33276&"
import script from "./LangItem.vue?vue&type=script&lang=js&"
export * from "./LangItem.vue?vue&type=script&lang=js&"
import style0 from "./LangItem.vue?vue&type=style&index=0&id=bfb33276&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports